<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M-.813-.813h21.625v21.625H-.813V-.813z" />
    <path
      d="M10 .089c5.474 0 9.911 4.437 9.911 9.911 0 5.474-4.437 9.911-9.911 9.911C4.526 19.911.089 15.474.089 10 .089 4.526 4.526.089 10 .089zm.901 4.505H9.1v7.208h6.307V10h-4.505V4.594z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
